'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extend = require('@souche-f2e/extend');

var _extend2 = _interopRequireDefault(_extend);

var _bury = require('./bury');

var _bury2 = _interopRequireDefault(_bury);

var _platform_keys = require('./platform_keys');

var _platform_keys2 = _interopRequireDefault(_platform_keys);

var _variable = require('./variable');

var _variable2 = _interopRequireDefault(_variable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bury = null; // 埋点类

var updateParams = function updateParams(Vue, el, binding) {
    var params = {};
    var val = binding ? binding.value : el;

    if (typeof val === 'string') {
        params.typeId = val;
    }

    if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
        params = val;
    }

    params.platform = (0, _platform_keys2.default)(params.platform) || (0, _platform_keys2.default)(Vue.buryOptions.platform);
    return params;
};
// 手动打点方法
var bury = function bury(Vue, val) {
    var params = updateParams(Vue, val);

    return new Bury().request((0, _extend2.default)(Vue.buryOptions, params));
};

/**
 * Vue bury plugin
 *
 * @param {Object} options [description]
 * @param {String} [options.env=production]    环境（development, prepub, production）
 * @param {String} [options.baseOptions]    环境（dev, prepub, prod）
     * @param {String} [options.baseOptions.token]      有手机号时用token,无手机号的时候可以不传
     * @param {String} [options.baseOptions.usertag]    userTag  不需要，则不用传
     * @param {String} [options.baseOptions.platform]   平台 key，如果不传则按照 ua 去判断
 * @param {Function}[options.preBury]   埋点钩子函数，会在执行埋点之前调用函数
 */
exports.default = {
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // 埋点的公共配置
        Vue.buryOptions = options.baseOptions || {};
        _variable2.default.send = options.send || _variable2.default.send;
        _variable2.default.setApp(options.app);

        Bury = _bury2.default.init(Vue, options.env);

        Vue.directive('bury', {
            bind: function bind(el, binding) {
                el.bury = new Bury();
                el.directiveValue = {};

                el.clickHandler = function () {
                    if (!Vue.buryOptions.disable) {
                        // 用于在发送埋点请求之前，执行一些操作
                        var preBuryHandler = typeof Vue.buryOptions.preBury === 'function' ? Vue.buryOptions.preBury : function (callback) {
                            callback();
                        };

                        preBuryHandler(function () {
                            el.bury.request((0, _extend2.default)(Vue.buryOptions, el.directiveValue));
                        });
                    }
                }.bind(el);

                el.directiveValue = updateParams(Vue, el, binding);

                el.addEventListener('click', el.clickHandler, true);
            },
            update: function update(el, binding) {
                el.directiveValue = updateParams(Vue, el, binding);
            },
            unbind: function unbind(el) {
                el.removeEventListener('click', el.clickHandler, true);
            }
        });

        // 支持手动打点
        Vue.prototype.$bury = function (val) {
            return bury(Vue, val);
        };
        this.bury = function (val) {
            return bury(Vue, val);
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-vue/vue-burying/dist/index.js
// module id = 4Mz5
// module chunks = 11